import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowLeft, Menu } from "lucide-react";
import { ContactModal } from "./ContactModal";
import { STRINGS } from "../i18n";
import { EASE, LOGO } from "./shared";

export function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const [lang, setLang] = useState(() => localStorage.getItem("vira-lang") || "en");
  const { pathname } = useLocation();
  const home = pathname === "/";
  const t = STRINGS[lang];
  const rtl = lang === "ar";
  useEffect(() => {
    if (home) document.title = t.title;
    document.documentElement.lang = lang;
    document.documentElement.dir = rtl ? "rtl" : "ltr";
    localStorage.setItem("vira-lang", lang);
  }, [lang, rtl, t.title, home]);
  const openContact = () => { setContactOpen(true); setMenuOpen(false); };
  const Arrow = rtl ? ArrowLeft : ArrowRight;
  const sectionHref = (id) => (home ? `#${id}` : `/#${id}`);
  return (
    <div className="site-shell">
      <div className="star-field" aria-hidden="true" />
      <motion.header className="site-header" data-testid="site-header" initial={{ y: -30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.7, ease: EASE }}>
        <a className="brand" href={home ? "#top" : "/#top"} aria-label="VIRA — home" data-testid="brand-link"><img src={LOGO} alt="VIRA" className="brand-logo" data-testid="brand-logo" /></a>
        <nav className={menuOpen ? "main-nav nav-open" : "main-nav"} data-testid="main-navigation">
          <a href={sectionHref("about")} onClick={() => setMenuOpen(false)} data-testid="nav-about-link">{t.nav.about}</a>
          <a href={sectionHref("services")} onClick={() => setMenuOpen(false)} data-testid="nav-services-link">{t.nav.services}</a>
          <a href={sectionHref("why-us")} onClick={() => setMenuOpen(false)} data-testid="nav-why-link">{t.nav.why}</a>
          <a href="#contact" onClick={(event) => { event.preventDefault(); openContact(); }} data-testid="nav-contact-link">{t.nav.contact}</a>
        </nav>
        <button className="header-cta" onClick={openContact} data-testid="header-get-started-button">{t.cta} <Arrow size={15} /></button>
        <button className="lang-toggle" onClick={() => setLang(rtl ? "en" : "ar")} aria-label="Switch language" data-testid="language-toggle">{rtl ? "EN" : "عربي"}</button>
        <button className="menu-button icon-button" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle navigation" data-testid="mobile-menu-button"><Menu size={22} /></button>
      </motion.header>

      <Outlet context={{ t, rtl, lang, openContact }} />

      <footer className="site-footer" data-testid="site-footer"><a className="brand" href={home ? "#top" : "/#top"} aria-label="VIRA — home" data-testid="footer-brand-link"><img src={LOGO} alt="VIRA" className="brand-logo footer-logo" data-testid="footer-brand-logo" /></a><span>{t.footerTag}</span><span>{t.trust.join(" · ")}</span></footer>
      {contactOpen && <ContactModal onClose={() => setContactOpen(false)} t={t} rtl={rtl} />}
    </div>
  );
}
